import * as React from "react";
import { forwardRef } from "react";
const SvgUiArrowRight = ({
  title,
  titleId,
  ...props
}, ref) => <svg width={5} height={6} viewBox="0 0 5 6" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path transform="rotate(90 2.5 2.5)" d="M3 5 6 .5H0z" fill="currentColor" fillRule="evenodd" /></svg>;
const ForwardRef = forwardRef(SvgUiArrowRight);
export { ForwardRef as ReactComponent };